import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  //  User  ----------------------------------------------------------------------
  getUserList({ dispatch, commit }) {
    axios
      .get("User/ListUserMyMirab")
      .then((res) => {
        commit("setUserList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserInfo({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("User/UserInfo")
      .then((res) => {
        commit("setUserInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getUserJobs({ dispatch, commit }) {
    axios
      .get("User/JobTitle?OrderBy=startDate desc")
      .then((res) => {
        commit("setUserJobs", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAssetList({ dispatch, commit }) {
    axios
      .get("User/ListAsset")
      .then((res) => {
        commit("setAssetList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

    changePassword({ dispatch, commit }, data) {
        commit("setLoadingBtn", true, { root: true });
        axios
            .put("Account/ChangePassword", data)
            .then((res) => {
                dispatch(
                    "successPOSTHandler",
                    {
                        server: res,
                        message: alert.success.changePassword,
                        redirect: false,
                    },
                    { root: true }
                );
            })
            .catch((error) => {
                dispatch("errorPOSTHandler", error, { root: true });
            })
            .finally(() => {
                setTimeout(() => {
                    commit("setLoadingBtn", false, { root: true });
                }, 1000);
            });
    },

    forgetPassword({ dispatch, commit }, data) {
        commit("setLoadingBtn", true, { root: true });
        axios
            .post("Account/ForgetPassword", data)
            .then((res) => {
                if (res.data && res.data.status === 200) {
                    commit("setCheckCode", true, { root: true });
                    commit("setSuccess", res.data.message, { root: true });
                } else {
                    commit("setError", res.data.message, { root: true });
                }
            })
            .catch((error) => {
                dispatch("errorPOSTHandler", error, { root: true });
            })
            .finally(() => {
                setTimeout(() => {
                    commit("setLoadingBtn", false, { root: true });
                }, 1000);
            });
    },

    confirmForgetPassword({ dispatch, commit }, data) {
        commit("setLoadingBtn", true, { root: true });
        axios
            .post("Account/ConfirmPassword", data)
            .then((res) => {
                if (res.data && res.data.status === 200) {
                    dispatch(
                        "successPOSTHandler",
                        {
                            server: res,
                            message: alert.success.changePassword,
                            redirect: "Login",
                        },
                        { root: true }
                    );
                } else {
                    commit("setError", res.data.message, { root: true });
                }
            })
            .catch((error) => {
                dispatch("errorPOSTHandler", error, { root: true });
            })
            .finally(() => {
                setTimeout(() => {
                    commit("setLoadingBtn", false, { root: true });
                }, 1000);
            });
    },

  //  User Groups  ----------------------------------------------------------------------
  getGroupList({ dispatch, commit }) {
    axios
      .get("Group/ListGroupEntity")
      .then((res) => {
        commit("setGroupList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGroupNames({ dispatch, commit }, data) {
    axios
      .get("Group/ListGroupName/" + data)
      .then((res) => {
        commit("setGroupNames", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addGroupName({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Group/AddOrEditGroupName", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGroupName({ dispatch }, data) {
    axios
      .delete("Group/DeleteGroupName/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getGroupMembers({ dispatch, commit }, data) {
    axios
      .get("Group/ListGroupMember/" + data)
      .then((res) => {
        commit("setGroupMembers", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addGroupMember({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Group/AddOrEditGroupMember", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGroupMember({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Group/DeleteGroupMember/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  Notice  ----------------------------------------------------------------------
  getNoticeGroup({ dispatch, commit }) {
    axios
      .get("Notice/ListNoticeGroup")
      .then((res) => {
        commit("setNoticeGroup", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getNoticeList({ dispatch, commit }) {
    axios
      .get("Notice/ListNotice?Page=1&PageSize=10000&OrderBy=id desc")
      .then((res) => {
        commit("setNoticeList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserNoticeList({ dispatch, commit }) {
    axios
      .get(
        "Notice/ListNoticeUser?Page=1&PageSize=10000&Filter=StateRef=8&OrderBy=id desc"
      )
      .then((res) => {
        commit("setUserNoticeList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserArchiveNoticeList({ dispatch, commit }) {
    axios
      .get(
        "Notice/ListNoticeUser?Page=1&PageSize=10000&Filter=StateRef=10&OrderBy=id desc"
      )
      .then((res) => {
        commit("setUserArchiveNoticeList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagerNoticeList({ dispatch, commit }) {
    axios
      .get("Notice/ListNoticeManager?Page=1&PageSize=10000&OrderBy=id desc")
      .then((res) => {
        commit("setManagerNoticeList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagerHistoryNoticeList({ dispatch, commit }) {
    axios
      .get(
        "Notice/ListHistoryNoticeManager?Page=1&PageSize=10000&OrderBy=id desc"
      )
      .then((res) => {
        commit("setManagerHistoryNoticeList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getNoticeDetails({ dispatch, commit }, data) {
    axios
      .get("Notice/GetByNoticeId/" + data)
      .then((res) => {
        if (res.data.data) {
          commit("setNoticeDetails", res.data.data);
        } else {
          commit("setNoticeDetails", null);
          commit("setError", res.data.message, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserNoticeDetails({ dispatch, commit }, data) {
    axios
      .get("Notice/ShowDetails/" + data)
      .then((res) => {
        if (res.data.data) {
          commit("setUserNoticeDetails", res.data.data);
        } else {
          commit("setUserNoticeDetails", null);
          commit("setError", res.data.message, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  readNotice({ dispatch }, data) {
    axios
      .get("Notice/ReadUserNotice/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addNotice({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Notice/AddOrEditNotice", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "Dashboard",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  acceptNotice({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Notice/AcceptNoticeByManager/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteNotice({ dispatch }, data) {
    axios
      .delete("Notice/DeleteNotice/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteUserNotice({ commit, dispatch }, data) {
      commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Notice/DeleteUserNotice/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
        .finally(() => {
            setTimeout(() => {
                commit("setLoadingBtn", false, { root: true });
            }, 1000);
        });
  },

    deleteManagerNotice({ commit, dispatch }, data) {
        commit("setLoadingBtn", true, { root: true });
        axios
            .delete("Notice/DeleteNoticeByManager/" + data)
            .then((res) => {
                dispatch(
                    "successPOSTHandler",
                    {
                        server: res,
                        message: alert.success.delete,
                        redirect: false,
                    },
                    { root: true }
                );
            })
            .catch((error) => {
                dispatch("errorPOSTHandler", error, { root: true });
            })
            .finally(() => {
                    setTimeout(() => {
                        commit("setLoadingBtn", false, { root: true });
                    }, 1000);
            });
    },

  //    File Downloader ------------------------------------------------------------
  downloadFileAddress({ dispatch, commit }, data) {
    axios
      .get("File/Download?type=" + data.type + "&imgId=" + data.image, {
        responseType: "blob",
      })
      .then((res) => {
        commit("setFileAddress", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
